import prizeBaseliao from './assets/prize-baseliao.png';
import prizeHotpot from './assets/prize-hotpot.png';
import prizePoints from './assets/prize-points.png';
import coupon1 from './assets/coupon-1.png';
import coupon2 from './assets/coupon-2.png';
import coupon3 from './assets/coupon-3.png';
import coupon4 from './assets/coupon-4.png';

export interface PrizeItem {
  name: string;
  img: string;
}

// 幸运抽奖-奖品
export const prizes: PrizeItem[] = [
  { name: '德庄小火锅火锅底料', img: prizeBaseliao },
  { name: '重庆火锅周边冰箱贴', img: prizeHotpot },
  { name: '上游新闻积分商城积分', img: prizePoints },
];

// 优惠券领取（每 2 张一组，轮播展示）
export const coupons: string[] = [coupon1, coupon2, coupon3, coupon4];

export const couponGroups: string[][] = coupons.reduce<string[][]>(
  (groups, coupon, index) => {
    if (index % 2 === 0) {
      groups.push([coupon]);
    } else {
      groups[groups.length - 1].push(coupon);
    }
    return groups;
  },
  [],
);

// 活动奖品（文字列表，与抽奖奖品一致）
export const prizeNames: string[] = prizes.map((item) => item.name);

// 奖品类型：2 积分，3 实物
export const WORK_TYPE_POINTS = 2;
export const WORK_TYPE_PHYSICAL = 3;

// 从接口数据中读取 workType
export const readWorkType = (data: any): number =>
  Number(data && (data.workType || data.work_type)) || 0;

// 只有实物奖品（workType=3）才需要填写收货地址
export const isPhysicalPrize = (workType?: number): boolean =>
  Number(workType) === WORK_TYPE_PHYSICAL;

// 我的中奖记录
export interface PrizeRecord {
  // 中奖记录ID（接口返回，填写收货地址用）
  id?: number;
  date: string;
  name: string;
  // 奖品类型：2 积分，3 实物
  workType?: number;
  // 实物奖品需填写收货地址
  needAddress?: boolean;
  address?: string;
}

export const prizeRecords: PrizeRecord[] = [
  { date: '2026.09.15', name: '客户端积分+10' },
  { date: '2026.09.16', name: '德庄火锅底料', needAddress: true },
  { date: '2026.09.17', name: '客户端积分+50' },
  { date: '2026.09.18', name: '客户端积分+10' },
];
